import { render, staticRenderFns } from "./EditElement.vue?vue&type=template&id=6f3125b0&scoped=true&"
import script from "./EditElement.vue?vue&type=script&lang=js&"
export * from "./EditElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3125b0",
  null
  
)

export default component.exports